import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

export class Breadcrumb {

    private icon: string;
    private index: string;
    private backlink: string;
    private routes: BRoute[];

    constructor(icon: string, index: string, backlink?: string, routes?: BRoute[]) {
        this.icon = icon;
        this.index = index;
        this.backlink = backlink;
        this.routes = routes;
    }

    public get Icon() {
        return this.icon;
    }

    public get Index() {
        return this.index;
    }

    public get Backlink() {
        return this.backlink;
    }

    public get Routes() {
        return this.routes;
    }

    public set Icon(icon) {
        this.icon = icon;
    }

    public set Index(index) {
        this.index = index;
    }

    public set Routes(routes) {
        this.routes = routes;
    }

    public set Backlink(backlink) {
        this.backlink = backlink;
    }
}
